<template>
  
  <UiContentwrapper v-if="page" class="specifications-contentwrapper">
      <div class="col-start-2 col-span-8">
        
                               

            <!-- Article Content (directly displayed without toggle) -->
            <div class="grid grid-cols-8 gap-7">
              <div class="col-span-8 xsmall mb-8 content-html">
                <span v-html="page.body"></span>
              </div>
            </div>
          
        
      </div>
    </UiContentwrapper>
  <div v-else class="mx-8">
    <UiContentwrapper>
      <div class="col-start-2 col-span-8">
        <div>
          <h2 class="mb-4 mt-16 py-2">No specifications found</h2>
                    
        </div>
      </div>
    </UiContentwrapper>
  </div>
</template>

<script setup>

import {usePageStore} from '@/stores/pageStore';

const pageStore = usePageStore();

// Props
const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
});


const page = ref(null);

onMounted(async () => {
  console.log('mounted specifications');
  //gid://shopify/Page/693666546038
  //gid://shopify/OnlineStorePage/693666546038
  const specificationId = props.product.specifications.value.replace('OnlineStorePage', 'Page');  
  page.value = await pageStore.fetchPageByID(specificationId);
});


</script>

<style>
@reference "../../assets/css/main.css";
.cursor-pointer {
  cursor: pointer;
}

.content-html ul {
  list-style-type: disc;
  margin-left: 1.5rem;
  padding-left: 1.5rem;
}

.content-html li {
  margin-bottom: 0.5rem;
  font-size: 1rem;
  line-height: 1.5;
}

.content-html em {
  @apply not-italic text-sm;
}

.content-html table {
  width: 100%;
  border-collapse: collapse;
  @apply mb-12;
}

.content-html tr {
  border-bottom: 1px solid #AB9670; /* Add bottom border for each row */
}

.content-html th,
.content-html td {
  padding: 10px;
  text-align: left;
}

/* Add custom border color class */
.border-custom-color {
  border-color: #AB9670; /* Same color as .content-html tr border */
}

@media (max-width: 640px) { /* Small screens */
  .specifications-contentwrapper {
    padding: 16px !important;
  }

  .col-start-2 {
    grid-column-start: 1; /* Change to col-start-1 on small screens */
  }
  .col-span-8 {
    grid-column: span 10 / span 10; /* Change to col-span-10 on small screens */
  }
}
</style>